<i18n>
    {
        cn: {
            qa: '常见问题',
            back: '返回',
        },
        en: {
            qa: 'Frequently Asked Questions',
            back: 'Back',
        }
    }
</i18n>
<script>
import ContactForm from '../../components/contactForm.vue';

export default {
    name: "qaa",
    data() {
        return {
            activeIndex: null,
            indexNum: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨'],
            list: [
                {
                    title: '艺术家的插画需要多少预算？',
                    title_en: 'How much budget is required to commission an illustration from an artist?',
                    text: [
                        '所有的艺术家都是按照具体的需求来报价，具体的需求可能需要考量下面这些因素',
                    ],
                    text_en: [
                        'All artists provide quotations based on specific project requirements. To determine the budget, we usually need to consider the following factors:',
                    ],
                    type: 1,
                    list: [
                        {
                            title: '可交付成果是什么？',
                            title_en: 'What are the deliverables?',
                            text: [
                                '首先，你的品牌，没错，无论是国际知名品牌还是初创公司，我们都一视同仁，但如果您的品牌在行业里具有高知名度或者有非常好的声誉，艺术家会更乐意合作，并在价格方便提供便利。',
                                '第二，我们需要知道您需要多少幅插作品，以及这些作品的风格和复杂程度。您是否已经明确了主题，或者从艺术家的作品查看一些特别吸引您注意的例子会非常有用。您可以向我们提供一些复杂程度与您期待的相似的作品。通过这些信息，我们将能够计算出艺术家完成这项工作需要多长时间。如果您需要的是现有作品，可以直接到我们的图库中去选择，或者直接联系我们的商务，并告诉我们作品数量、可能的预算和指定的哪几幅作品。',
                            ],
                            text_en: [
                                'First, your brand. Whether you are an internationally renowned brand or a start-up company, we treat all clients equally. However, if your brand has strong industry recognition or an excellent reputation, artists are often more enthusiastic about collaborating and may be more flexible with pricing.',
                                'Second, we need to understand how many illustrations you require, as well as the style and level of complexity. Have you already defined a theme? It is also very helpful if you can share specific examples from the artist’s portfolio that particularly appeal to you, or references with a similar level of complexity to what you expect.',
                                'With this information, we can estimate how long the artist will need to complete the project.',
                                'If you are interested in existing artworks, you may select directly from our image library or contact our business team with the quantity, potential budget range, and the specific works you are interested in.'
                            ]
                        },
                        {
                            title: '我们需要知道艺术家的作品将被您如何使用？',
                            title_en: 'How will the artwork be used?',
                            text: [
                                '我们了解您希望艺术家创作什么之外，还需要讨论您将如何利用或使用他们，委托定制创作不意味着你完全拥有作品，艺术家将保留版权。您拥有的是一个许可使用权，该许可权利规定了您可以如何使用它以及在何处使用。因此，我们需要确定这些使用条款是什么。包括您会在哪些媒体上使用它们（在线、印刷、广告牌，线下商店等等）、还包括在世界的哪个国家/地区被看到和使用，它将被使用多长时间。一副作品使用得越多，它的成本就越高。另一方面，如果您对使用设置限制，成本就会下降。',
                                '我必须明确告诉您名单上艺术家我们是中国（含港澳台）的独家和战略合作代理，部分是亚洲地区和全球的独家代理，但如果你的授权国家包括中国但超出中国范围，例如你希望授权亚洲，请务必让我们知道，这涉及到艺术家在其他国家可能有其他的独家代理，或者在你希望授权的国家已经有排他的项目，我们会为您协商让您了解可行性。如果你希望授权地域不包括中国，则务必让我们与艺术家确认可行性，通常在中国的客户或在中国的品牌都是我们负责（我们也知道现在很多客户的产品是外贸或出海的，但不影响我们合作）',
                            ],
                            text_en: [
                                'Beyond understanding what you would like the artist to create, we also need to discuss how the work will be used. A commissioned project does not mean full ownership of the artwork — the artist retains the copyright.',
                                'What you acquire is a license granting usage rights. This license defines how and where the work may be used. Therefore, we need to clarify the usage terms, including:',
                                'The media channels (online, print, billboards, offline stores, etc.)',
                                'The countries/regions where the work will be visible and used',
                                'The duration of use',
                                'The broader and longer the usage, the higher the licensing cost. Conversely, more limited usage will result in a lower cost.',
                                'Please note that for the artists listed with us, we are the exclusive and strategic agency for China (including Hong Kong, Macau, and Taiwan). For some artists, we are also the exclusive agency for Asia or globally.',
                                'If your licensing territory includes China but extends beyond it (for example, if you are seeking rights for Asia), please inform us in advance. The artist may have other exclusive agents in certain countries, or there may already be exclusive projects in the territory you are targeting. We will coordinate and negotiate on your behalf and advise on feasibility.',
                                'If your licensing territory does not include China, we must also confirm feasibility directly with the artist. Generally, clients based in China or Chinese brands fall under our representation (including those exporting or operating internationally), which does not affect our cooperation.',
                            ]
                        },
                        {
                            title: '如果你需要不受限制，自由的永远以任何方式、在任何地方使用，这有可能吗？',
                            title_en: 'Is it possible to obtain unrestricted, perpetual, worldwide usage rights?',
                            text: [
                                '是的，我们经常协商并设置不受媒体限制，永久时效，甚至全球可使用，但艺术家仍保留版权。'
                            ],
                            text_en: [
                                'Yes, we frequently negotiate agreements that include unlimited media usage, perpetual duration, and even worldwide rights. However, the artist will always retain copyright ownership.'
                            ]
                        },
                        {
                            title: '还会不会有其他的费用？',
                            title_en: 'Will there be any additional costs?',
                            text: [
                                '有时候，项目可能需要艺术家出行或购买特定材料，有些项目可能需要摄影师，摄制组，剪辑和修图后期人员等。有项目要求艺术家将合作的内容发布在他自己的社交媒体账号上并关联客户的账号，以及那些发布的内容可以被客户用于宣传的。我们会尽可能准确地考虑这些成本，并将其纳入我们的报价中。'
                            ],
                            text_en: [
                                'In some cases, a project may require the artist to travel or purchase specific materials. Certain projects may also involve photographers, a production crew, video editing, and post-production retouching.',
                                'Some collaborations require the artist to publish the content on their own social media accounts and tag the client, and in some cases, allow the client to reuse the published content for promotional purposes.',
                                'We will take all these potential costs into careful consideration and include them as accurately as possible in our quotation.'
                            ]
                        },
                        {
                            title: '提供的价格还能有商量的余地么？',
                            title_en: 'Is there room for negotiation on the quoted price?',
                            text: [
                                '如果您提供了上述的具体需求信息，我们将很快提供您初步的报价，但依然可以被协商，最终费用将以完全签署协议为准。但通常我们提供的价格都很准确。'
                            ],
                            text_en: [
                                'Once you provide the detailed requirements mentioned above, we will offer a preliminary quotation promptly. The price remains negotiable, and the final fee will be subject to a fully signed agreement.That said, the quotations we provide are generally already quite accurate.'
                            ]
                        },
                    ]
                },
                {
                    title: '如果是委托定制创作的作品，艺术家的创作周期大概有多久？',
                    title_en: 'If the project involves a commissioned custom artwork, how long is the artist’s creation timeline?',
                    text: [
                        '从您订单确认并支付后，需要提供非常详细的创作需求，如果你是个新手，我们会提供一个模版，并引领您提供出明确细节的需求，艺术家收到创作需求后会提出一些问题来明确理解您的内容，之后他们就开始进入创作工作。艺术家创作的时间从2周到几个月不等，有鉴于项目的复杂程度，请至少提供足够的创作时间和前期沟通时间这样才能得到优秀且满足你需求的作品。如果你没有足够的时间，建议你能直接选择现有作品授权。',
                    ],
                    text_en: [
                        'After your order is confirmed and payment is made, you will need to provide very detailed creative requirements. If you are new to this process, we will provide a template and guide you step by step to help clarify and refine your brief.',
                        'Once the artist receives the creative brief, they may raise additional questions to ensure a clear understanding of your expectations before beginning the creation process.',
                        'The creation timeline can range from two weeks to several months, depending on the complexity of the project. We strongly recommend allowing sufficient time for both early-stage communication and the creative process in order to achieve high-quality results that fully meet your expectations.',
                        'If your timeline is tight, we suggest selecting from existing artworks for licensing instead.'
                    ]
                },
                {
                    title: '品牌可以授权现有的作品吗？',
                    title_en: 'Can a brand license existing artworks?',
                    text: [
                        '当然，但取决于该作品的相关授权许可协议，如果该作品是有效的（有些作品涉及到排它，所以我们需要事先明确您选择的作品是有效的），我们将很乐意与您沟通许可授权的费用。您也可以去我们的作品库中挑选。或者告诉我们你的需求，我们为您提供相关建议作品和艺术家。',
                    ],
                    text_en: [
                        'Yes, absolutely. However, this depends on the specific licensing status of the artwork. Some works may be subject to exclusive agreements, so we need to confirm in advance whether the piece you are interested in is available.',
                        'If the artwork is available, we would be happy to discuss the licensing fees with you. You are also welcome to browse and select from our artwork library. Alternatively, you may share your requirements with us, and we can recommend suitable artworks and artists accordingly.'
                    ]
                },
                {
                    title: '作为客户能直接与艺术家沟通吗？',
                    title_en: 'Can clients communicate directly with the artist?',
                    text: [
                        '一般情况下我们不建议您直接联系艺术家，无论在文化和习惯上的差异，还是工作方式上的不同，我们都希望您的项目能顺利进行，而与艺术家良好的信任关系与沟通技巧很多时候能让项目进行的更加顺利，这也是我们存在的意义。但针对一些特殊的案子，例如艺术家与品牌的长期合约，这个时候可能需要更深入的了解品牌或者需要提供品牌更深入的服务的时候，艺术家的直接参与是有必要的，但我们会时刻密切关注并抄送电子邮件并进行视频通话等。如果需要，我们会随时帮助任何一方并让流程顺利进行。',
                    ],
                    text_en: [
                        'In general, we do not recommend direct communication with the artist. Differences in culture, working habits, and communication styles can sometimes create misunderstandings. Our role is to ensure that your project runs smoothly. A strong foundation of trust and effective communication with the artist often helps projects move forward efficiently — and this is precisely the value we provide.',
                        'However, in certain special cases, such as long-term contracts between an artist and a brand, deeper engagement may be necessary. When the artist needs a more comprehensive understanding of the brand or is expected to provide more in-depth services, direct involvement can be appropriate.',
                        'In such situations, we will remain closely involved in all communications, including being copied on emails and participating in video calls when necessary. If needed, we will support either party at any time to ensure a smooth and successful process.'
                    ]
                },
                {
                    title: '如果在网站上找到艺术家，能不能直接联系他们？',
                    title_en: 'If we find an artist on your website, can we contact them directly?',
                    text: [
                        '我们的艺术家从幕后工作中受益匪浅。首先，我们投入了大量的时间和金钱来推广我们的机构和他们的作品。然后，当涉及到项目时，我们会处理谈判、合同（您知道每个国家的法律是不同的，当涉及国际的合约时，是需要有专业的人提供专业的服务）、报价和项目管理，这样让艺术家和客户都更轻松。但归根到底还是需要讲究礼仪。请始终先与我们联系。',
                    ],
                    text_en: [
                        'Our artists greatly benefit from the work we do behind the scenes. First, we invest significant time and resources in promoting both our agency and their work. When it comes to projects, we handle negotiations, contracts (as you know, laws vary from country to country, and international agreements require professional expertise), quotations, and overall project management. This ensures a smoother and more efficient experience for both the artist and the client. Ultimately, it is also a matter of professional etiquette. We kindly ask that you always contact us first.'
                    ]
                },
                {
                    title: '如果之前从未委托过艺术家，您能帮助我们吗？',
                    title_en: 'If we have never commissioned an artist before, can you assist us?',
                    text: [
                        '当然。我们与各行业和各种类型的客户合作，有些客户在与艺术家合作方面经验丰富，但有些客户则是第一次。如果您之前从未委托过艺术家，我们的团队将指导您完成整个过程。甚至帮助您整理一份简介（包括可能的翻译）以及委托创作的注意事项。',
                    ],
                    text_en: [
                        'Absolutely. We work with clients across various industries and of different sizes. Some have extensive experience collaborating with artists, while others are doing so for the first time.',
                        'If you have never commissioned an artist before, our team will guide you through the entire process. We can even help you prepare a clear and structured brief (including translation if needed) and advise you on key considerations for a commissioned project.'
                    ]
                },
                {
                    title: '根据不同的需求，我们需要提交哪些信息请求？',
                    title_en: 'What information do we need to submit based on different project requirements?',
                    text: [
                        '除了了解艺术家和您想要授权的艺术作品名称之外，请务必收集尽可能多的有关您的项目信息。获得使用艺术家作品的许可是确保您的项目不仅符合法律标准，而且尊重相关艺术家的创作努力的关键步骤。无论您是在制作电影、书籍、广告活动还是任何其他创意作品，奢颜艺术都会指导您完成每一步。请记住，尊重版权不仅仅是一项法律义务，也是一种对道德创造力的承诺，可以增强您作品的完整性和影响力。',
                    ],
                    text_en: [
                        'In addition to identifying the artist and the specific artwork you wish to license, please gather as much detailed information about your project as possible. Obtaining permission to use an artist’s work is a crucial step to ensure that your project not only complies with legal standards but also respects the creative efforts of the artist.',
                        'Whether you are producing a film, book, advertising campaign, or any other creative project, Ambassador+ ART will guide you through every step of the process. Please remember that respecting copyright is not only a legal obligation, but also a commitment to ethical creativity that strengthens the integrity and impact of your work.'
                    ],
                    type: 2,
                    list: [
                        {
                            title: '商品用途：',
                            title_en: 'Product Usage:',
                            text: [
                                '产品类型',
                                '零售/批发价',
                                '生产数量',
                                '分销——它将在哪里销售？',
                                '请求的许可期限',
                                '产品和包装的布局'
                            ],
                            text_en: [
                                'Product type',
                                'Retail/wholesale price',
                                'Production quantity',
                                'Distribution – where will it be sold?',
                                'Requested license term',
                                'Product and packaging layout'
                            ]
                        },
                        {
                            title: '社交媒体用途：',
                            title_en: 'Social Media Usage:',
                            text: [
                                '每个平台/个人资料的关注者数量',
                                '标准广告或增强/赞助广告',
                                '图片及附带文字',
                            ],
                            text_en: [
                                'Number of followers per platform/profile',
                                'Standard post or boosted/sponsored advertisement',
                                'Image(s) and accompanying caption text'
                            ]
                        },
                        {
                            title: '数字广告或网站展示：',
                            title_en: 'Digital Advertising or Website Display:',
                            text: [
                                '网站网址',
                                '页面描述',
                                '广告类型（侧边栏、横幅、弹出）',
                                '如果用于广告则提供 PDF 的模版',
                            ],
                            text_en: [
                                'Website URL',
                                'Page description',
                                'Type of advertisement (sidebar, banner, pop-up, etc.)',
                                'PDF template if used for advertising'
                            ]
                        },
                        {
                            title: '横幅、壁画和标志等展示用途：',
                            title_en: 'Display Usage (Banners, Murals, Signage, etc.):',
                            text: [
                                '位置',
                                '显示屏尺寸和材质',
                                '印刷件或屏幕数量（如果适用）',
                                'PDF 样例',
                            ],
                            text_en: [
                                'Location',
                                'Display size and material',
                                'Number of printed pieces or screens (if applicable)',
                                'Sample PDF'
                            ]
                        },
                        {
                            title: '印刷用途，如书籍、电子书、目录或杂志：',
                            title_en: 'Print Usage (Books, e-books, catalogs, magazines, etc.):',
                            text: [
                                '出版物标题/描述',
                                '印刷数量或流通量',
                                '地域分布（中国或全球）',
                                '出版物将以以下语言印刷',
                                '复制件的尺寸（1/2 页、整页、¼ 页、双页等）',
                                '该图像是出现在封面、封底还是书籍封面上？',
                                '如果适用，该出版物的零售价是多少？',
                                '对于封面使用，PDF 模型',
                                '您的出版物是专著吗？换句话说，您的出版物中 40% 的内容是专门介绍某位艺术家的作品吗？',
                            ],
                            text_en: [
                                'Title/description of the publication',
                                'Print run or circulation',
                                'Geographic distribution (China or worldwide)',
                                'Language(s) of publication',
                                'Size of reproduction (half-page, full-page, quarter-page, double spread, etc.)',
                                'Will the image appear on the cover, back cover, or inside cover?',
                                'If applicable, what is the retail price of the publication?',
                                'For cover use, provide a PDF mockup',
                                'Is your publication a monograph? In other words, does 40% or more of the content focus specifically on one artist’s work?'
                            ]
                        },
                        {
                            title: '电影、电视或视频用途：',
                            title_en: 'Film, Television, or Video Usage:',
                            text: [
                                '剧情简介，包括演员和导演',
                                '为什么选择这位艺术家和这件特别的作品来演绎这个场景？',
                                '剧本中是否引用了艺术作品？或者“未引用”，只是背景布景？',
                                '您需要额外的促销权利吗？',
                                '这件艺术品将在屏幕上停留多长时间？',
                            ],
                            text_en: [
                                'Synopsis, including cast and director',
                                'Why was this particular artist and artwork chosen for the scene?',
                                'Is the artwork referenced in the script, or is it simply background set decoration?',
                                'Do you require additional promotional rights?',
                                'How long will the artwork appear on screen?'
                            ]
                        },
                        {
                            title: '演出、讲座或现场活动：',
                            title_en: 'Performances, Lectures, or Live Events:',
                            text: [
                                '演出或活动的开始和结束日期',
                                '会场',
                                '席位数量',
                                '入场费或费用范围',
                                '艺术品将如何展出？',
                                '会展示多久？',
                                '是否会进行现场直播、录制或者在线播放？',
                            ],
                            text_en: [
                                'Start and end dates of the performance/event',
                                'Venue',
                                'Seating capacity',
                                'Ticket price or price range',
                                'How will the artwork be displayed?',
                                'For how long will it be displayed?',
                                'Will the event be live-streamed, recorded, or available online?'
                            ]
                        },
                    ]
                },
                {
                    title: '其实我也是个艺术家，你们是否愿意代表我？',
                    title_en: 'I’m also an artist — would you be willing to represent me?',
                    text: [
                        '有可能，说实话，作为一家代理机构，需要更多专心在我们的范围内，我们的确有些忙不过来，因为希望对每个艺术家和客户都尽心尽力，你知道那需要花费很多时间和经历。但作为我们这样的代理机构总是有空间的。如果您认为您的作品与我们名单上的其他艺术家不同，并且确实能为我们的代理机构增添新意，请不要犹豫向我们提交作品。如果我们喜欢看到的作品，我们会与您联系。有时候部分艺术家的作品真让我们惊叹。',
                    ],
                    text_en: [
                        'Possibly. To be honest, as an agency, we need to remain focused within our scope, and at times we are already quite busy. We strive to dedicate genuine care and attention to every artist and client we represent — and as you know, that requires a great deal of time and energy.That said, agencies like ours are always open to discovering new talent. If you believe your work stands out from the other artists on our roster and would truly bring something fresh and distinctive to our portfolio, please don’t hesitate to submit your work to us.If we are impressed by what we see, we will get in touch with you. Occasionally, we come across artists whose work genuinely amazes us.'
                    ]
                },
            ],
            history : window.history.length
        };
    },
    computed: {},
    components: {
        ContactForm
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        show(index) {
            if (this.activeIndex == index) { 
                this.activeIndex = null;
            } else {
                this.activeIndex = index;
                this.$nextTick(() => {
                    let offsetTop = this.$refs.qaa[index].offsetTop;
                    setTimeout(() => {
                        window.scrollTo({
                            top: offsetTop,
                            behavior: "smooth",
                        });
                    }, 300)
                })
            }
        }
    },
};
</script>

<template>
    <div class="qaa">
        <div class="layout_main wrapper">
            <div class="title">{{ $t('qa') }}</div>
            <div class="list">
                <div class="item" ref="qaa" v-for="(item, index) in list" :key="index" :class="{active: activeIndex == index}">
                    <div class="question flex justify_between align_center">
                        <p v-if="$i18n.locale === 'en'">{{ item.title_en }}</p>
                        <p v-else>{{ item.title }}</p>
                        <div class="icon" @click="show(index)"></div>
                    </div>
                    <div class="answer">
                        <!--  -->
                        <template v-if="$i18n.locale === 'en'">
                            <p class="text" v-for="(_item, _index) in item.text_en" :key="_index" v-html="$textToHtml(_item)"></p>
                        </template>
                        <template v-else>
                            <p class="text" v-for="(_item, _index) in item.text" :key="_index" v-html="$textToHtml(_item)"></p>
                        </template>
                        <!--  -->
                        <div class="list" :class="`type${item.type}`" v-if="item.list && item.list.length > 0">
                            <div class="item" v-for="(_item, _index) in item.list" :key="_index">
                                <p class="title">
                                    <span v-if="item.type == 1">{{ indexNum[_index] }} </span>
                                    <span v-if="$i18n.locale === 'en'">{{ _item.title_en }}</span>
                                    <span v-else>{{ _item.title }}</span>
                                </p>
                                <div class="text" v-if="$i18n.locale === 'en'">
                                    <p v-for="(__item, __index) in _item.text_en" :key="__index">
                                        <span v-if="item.type == 2">{{ indexNum[__index] }} </span>
                                        <span>{{ __item }}</span>
                                    </p>
                                </div>
                                <div class="text" v-else>
                                    <p v-for="(__item, __index) in _item.text" :key="__index">
                                        <span v-if="item.type == 2">{{ indexNum[__index] }} </span>
                                        <span>{{ __item }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify_end" v-if="history > 2"><div class="btn" @click="$router.go(-1)">{{ $t('back') }}</div></div>
            <div class="flex justify_end" v-else><router-link class="btn" to="/talents">{{ $t('back') }}</router-link></div>
        </div>
        <ContactForm from="人才"/>
    </div>
</template>

<style scoped lang="scss">
.wrapper{
    padding: .5rem 0;
    >.title{
        font-size: .3rem;
        @media only screen and (max-width: 750px) {
            font-size: .36rem;
            font-weight: bold;
        }
    }
    .btn{
        font-size: .18rem;
        margin-top: .2rem;
        cursor: pointer;
        @media only screen and (max-width: 750px) {
            display: none;
        }
    }
    >.list{
        letter-spacing: .04em;
        line-height: 1.6;
        >.item{
            border-bottom: 1px solid #666;
            padding: .2rem 0;
            margin-bottom: .35rem;
            @media only screen and (max-width: 750px) {
                margin-bottom: 0;
                padding: .45rem 0;
                border-bottom-color: #ccc;
            }
            &:last-child{
                margin-bottom: 0;
            }
            &.active{
                .question{
                    .icon{
                        &::after{
                            display: none;
                        }
                    }
                }
                .answer{
                    display: block;
                }
            }
            .question{
                font-size: .22rem;
                @media only screen and (max-width: 750px) {
                    font-size: .32rem;
                }
                .icon{
                    flex-shrink: 0;
                    margin-left: .2rem;
                    width: .4rem;
                    height: .4rem;
                    border: 1px solid #666;
                    border-radius: 50%;
                    position: relative;
                    cursor: pointer;
                    &::before,
                    &::after{
                        content: "";
                        display: block;
                        width: 60%;
                        border-bottom: 1px solid #666;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                    &::after{
                        transform: translate(-50%, -50%) rotate(90deg);
                    }
                }
            }
            .answer{
                display: none;
                font-size: .2rem;
                padding: .3rem 0;
                @media only screen and (max-width: 750px) {
                    font-size: .3rem;
                }
                >.text{
                    margin-bottom: .2rem;
                    &:last-child{
                        margin-bottom: 0;
                    }
                }
                .list{
                    padding: .5rem 0 0 .4rem;
                    @media only screen and (max-width: 750px) {
                        padding-left: 0;
                    }
                    .item{
                        margin-bottom: .5rem;
                        &:last-child{
                            margin-bottom: 0;
                        }
                        .title{
                            margin-bottom: .2rem;
                        }
                        .text{
                            @media only screen and (max-width: 750px) {
                                font-weight: 100;
                                color: #666;
                            }
                        }
                    }
                    &.type1{
                        .item{
                            .title{
                                font-weight: bold;
                                @media only screen and (max-width: 750px) {
                                    font-weight: normal;
                                }
                            }
                            .text p{
                                margin-bottom: .2rem;
                            }
                        }
                    }
                    &.type2{
                        .item{
                            display: flex;
                            @media only screen and (max-width: 750px) {
                                display: block;
                            }
                            .title{
                                white-space: nowrap;
                                @media only screen and (max-width: 750px) {
                                    white-space: normal;
                                }
                            }
                            .text{
                                display: flex;
                                flex-wrap: wrap;
                                gap: .04rem;
                                @media only screen and (max-width: 750px) {
                                    display: block;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>